import { GenericDialog } from '@AMIEWEB/Alerts/GenericDialog';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, CircularProgress, Grid } from '@mui/material';
import { DialogButtonComponent } from './DialogComponents/DialogButtonComponent';
import modsDialogStyles from './DialogComponents/Styles/PlacementMods.styles';
import { Cancel } from 'app/components/Common/CancelModal/Cancel';
import { FormatDate } from '@AMIEWEB/Notification/Tasks/Common/FormatData';
import { ModsComponent } from '../ModsComponents/ModsComponent';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCurrentModDetails,
  selectIsEditExistingMod,
  selectIsEditMod,
  selectIsGridModAltered,
  selectModSavedStatus,
  selectIsGridModError,
  selectEditTimeOffRows,
  selectReimbursementCategoryAndFrequency,
  selectEditFurnitureRows,
  selectEditUtilitiesRows,
  selectIsAdultGridmoderror,
  selectIsAdultGridmodAltered,
  selectIsChildrenGridmodAltered,
  selectIsChildrenGridmodError,
  selectIsPetsGridModError,
  selectIsPetsGridmodAltered,
  selectEditPayrollShiftDifferentialRows,
  selectEditBillingShiftDifferentialRows,
  selectShiftDifferentialDescriptionTypes,
  selectShiftDifferentialTypes,
  selectPreferenceGridDetails,
  selectPreferenceGridEmptyError,
  selectDoesHousingBannerDisplay,
  selectholdBannerShownState,
  selectIsEmiLmoDisabled,
  selectPayRateGww,
  selectPricingReason,
  selectIsApprovedTravelerBonus,
  selectIsApprovedNonTravelerBonus,
  selectIsRowInEditMode,
} from 'store/redux-store/placement-mods/selectors';
import { WhiteTooltip } from 'app/components/Common/Tooltips/WhiteTooltip';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import {
  AddEmiLmoDescription,
  AddMinReqHoursDescription,
  EditEmiLmoDescription,
  EditMinReqHoursDescription,
  EmiLmo,
  EmiLmoDescription,
  EndDate,
  MinReqHours,
  MinReqHoursDescription,
  StartDate,
  addOgpIntlLoanDescription,
  editOgpIntlLoanDescription,
  effectiveDateErrorCode,
  housingInfoMsgCode,
  interimNoTimeoffAssociated,
  ogpIntlLoan,
  ogpIntlLoanDescription,
  refreshErrorCode,
  timeOffAdd,
  timeOffDescription,
  timeOffEdit,
  timeoff,
} from 'app/models/Placement/PlacementMods';
import {
  getFormattedFurniture,
  getFormattedTimeOff,
  getFormattedUtility,
  getModsWidth,
  sanitizeString,
  selectedModValue,
  getFormattedPayrollShiftDifferential,
  getFormattedBillingShiftDifferential,
} from '../ModificationsUtils';
import { usePromiseTracker } from 'react-promise-tracker';
import { Undo } from '@AMIEWEB/Common/UndoModal/Undo';
import { useParams } from 'react-router-dom';
import _ from 'lodash';
import { CannotApprovedModal } from './CannotApprovedModal/CannotApprovedModal';
import { ModsFormBanner } from './DialogComponents/ModsFormBanner';
import moment from 'moment';
import { TemplateTypes } from './Utils';
import { selectPlacementHeaderData } from 'store/redux-store/placement-details/selectors';

export const PlacementModsDialog = ({
  modsDialogDetails,
  setModsDialogDetails,
  selectedRowDetails,
  defaultModDetails,
  setSelectedRowDetails,
}: {
  modsDialogDetails: any;
  setModsDialogDetails: any;
  selectedRowDetails: any;
  defaultModDetails: any;
  setSelectedRowDetails: any;
}) => {
  const isApprovedTravelerBonus = useSelector(selectIsApprovedTravelerBonus);
  const isApprovedNonTravelerBonus = useSelector(selectIsApprovedNonTravelerBonus);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [expanded, setExpanded] = React.useState<boolean>(false);
  const currentModDetails = useSelector(selectCurrentModDetails);
  const reimbursementCategoryAndFrequency = useSelector(selectReimbursementCategoryAndFrequency);
  const [showVoidButton, setShowVoidButton] = useState(false);
  const [undoButtonChanges, setUndoButtonChanges] = useState(false);
  const [effectiveDateAltered, setAlteredEffectiveDate] = useState(false);
  const [effectiveDateError, setEffectiveDateError] = useState({ status: false, helperText: '' });
  const modSavedResponse = useSelector(selectModSavedStatus);
  const isGridModError = useSelector(selectIsGridModError);
  const isAdultGridmoderror = useSelector(selectIsAdultGridmoderror);
  const isChildrenGridmodError = useSelector(selectIsChildrenGridmodError);
  const isPetsGridModError = useSelector(selectIsPetsGridModError);
  const isAdultGridmodAltered = useSelector(selectIsAdultGridmodAltered);
  const isChildrenGridmodAltered = useSelector(selectIsChildrenGridmodAltered);
  const isPetsGridmodAltered = useSelector(selectIsPetsGridmodAltered);
  const isGridModAltered = useSelector(selectIsGridModAltered);
  const isRowInEditMode = useSelector(selectIsRowInEditMode);
  const [openCancelModel, setCancelModalOpen] = useState(false);
  const isEditExistingMod = useSelector(selectIsEditExistingMod);
  const timeOffEditRequests = useSelector(selectEditTimeOffRows);
  const furnitureEditRequests = useSelector(selectEditFurnitureRows);
  const utilityEditRequests = useSelector(selectEditUtilitiesRows);
  const payrollShiftEditRequests = useSelector(selectEditPayrollShiftDifferentialRows);
  const billingShiftEditRequests = useSelector(selectEditBillingShiftDifferentialRows);
  const preferenceModEditRequests = useSelector(selectPreferenceGridDetails);
  const preferenceGridEmptyError = useSelector(selectPreferenceGridEmptyError);
  const gwwExceptionsTypes = useSelector(selectPayRateGww);
  const pricingReasons = useSelector(selectPricingReason);
  const [openApprovalModal, setOpenApprovalModal] = useState(false);
  const [failedAddMod, setFailedAddMod] = useState(false);
  const [noOptions, setNoOptions] = useState(false);
  const { promiseInProgress: isCallingAPI } = usePromiseTracker({ area: 'mod-details-api', delay: 0 });
  const { promiseInProgress: isTimeOffCallingAPI } = usePromiseTracker({ area: 'timeoff-details-api', delay: 0 });
  const isEmiLmoDisabled = useSelector(selectIsEmiLmoDisabled);
  const { promiseInProgress: isPayrollShiftDifferentialCallingAPI } = usePromiseTracker({
    area: 'payroll-shift-differential-api',
    delay: 0,
  });
  const { promiseInProgress: isCallingInterimAPI } = usePromiseTracker({
    area: 'interim-travel-details-api',
    delay: 0,
  });
  const { promiseInProgress: isCallingPreferencesAPI } = usePromiseTracker({
    area: 'preferences-details-api',
    delay: 0,
  });
  const { promiseInProgress: isCallingFurnitureAPI } = usePromiseTracker({
    area: 'furniture-details-api',
    delay: 0,
  });
  const { promiseInProgress: isBillingShiftDifferentialCallingAPI } = usePromiseTracker({
    area: 'billing-shift-differential-api',
    delay: 0,
  });
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const { promiseInProgress: isVoidModApiCalling } = usePromiseTracker({ area: 'post-mod-api', delay: 0 });
  const { promiseInProgress: isDeleteModApiCalling } = usePromiseTracker({ area: 'delete-mod-api', delay: 0 });

  const param = useParams<{ placementId: string }>();
  const shiftDifferentialTypes = useSelector(selectShiftDifferentialTypes);
  const shiftDifferentialDescriptionTypes = useSelector(selectShiftDifferentialDescriptionTypes);
  const [openUndoModal, setOpenUndoModal] = useState(false);
  const placementDetails = useSelector(selectPlacementHeaderData);

  const formMethods = useForm({
    defaultValues: defaultModDetails,
    mode: 'onChange',
  });

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors, dirtyFields },
  } = formMethods;

  const isDirty = !_.isEmpty(dirtyFields);

  const callingAPI = () => {
    if (
      selectedModValue(modsDialogDetails) === 'Timeoff' ||
      selectedModValue(modsDialogDetails) === 'InterimTravel' ||
      selectedModValue(modsDialogDetails) === 'Furniture' ||
      selectedModValue(modsDialogDetails) === 'Preferences' ||
      selectedModValue(modsDialogDetails) === 'PayrollShiftDifferential' ||
      selectedModValue(modsDialogDetails) === 'BillingShiftDifferential'
    ) {
      if (
        !currentModDetails &&
        (isTimeOffCallingAPI ||
          isCallingInterimAPI ||
          isCallingFurnitureAPI ||
          isCallingPreferencesAPI ||
          isPayrollShiftDifferentialCallingAPI ||
          isBillingShiftDifferentialCallingAPI)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return isCallingAPI;
    }
  };
  const isModEdit = useSelector(selectIsEditMod);
  const [selectedButton, setSelectedButtons] = useState({
    acceptedStatus: null,
    approvedStatus: null,
    isDelete: false,
    isVoid: false,
    effectiveDate: null,
  });

  const { classes } = modsDialogStyles({
    expanded,
    isDelete: selectedButton?.isDelete,
    isVoid: selectedButton?.isVoid,
    isCallingAPI: callingAPI(),
  });
  const [defaultModState, setDefaultModState] = useState(null);

  const dialogTitle = () => {
    const selectedMod = selectedModValue(modsDialogDetails);
    switch (selectedMod) {
      case MinReqHours:
        if (isEditExistingMod) {
          return EditMinReqHoursDescription;
        } else if (isModEdit) {
          return AddMinReqHoursDescription;
        } else {
          return MinReqHoursDescription;
        }
      case ogpIntlLoan:
        if (isEditExistingMod) {
          return editOgpIntlLoanDescription;
        } else if (isModEdit) {
          return addOgpIntlLoanDescription;
        } else {
          return ogpIntlLoanDescription;
        }
      case timeoff:
        if (isEditExistingMod) {
          return timeOffEdit;
        } else if (isModEdit) {
          return timeOffAdd;
        } else {
          return timeOffDescription;
        }
      case EmiLmo:
        if (isEditExistingMod) {
          return EditEmiLmoDescription;
        } else if (isModEdit) {
          return AddEmiLmoDescription;
        } else {
          return EmiLmoDescription;
        }
      default:
        if (isEditExistingMod) {
          return `Edit ${modsDialogDetails.selectedMod}`;
        } else if (isModEdit) {
          return `Add ${modsDialogDetails.selectedMod}`;
        } else {
          return modsDialogDetails.selectedMod;
        }
    }
  };

  const isDateModGreaterBookingDate = () => {
    const modName = selectedRowDetails?.type?.replaceAll(/['/.\s]/g, '');
    return (
      (modName === 'StartDate' || modName === 'EndDate') &&
      isEditExistingMod &&
      currentModDetails?.isBookingApprovedOrGreater &&
      (currentModDetails.approvalStatusId === 1 || currentModDetails.approvalStatusId === 4)
    );
  };

  const isTimeOffModDate = () => {
    const modName = selectedRowDetails?.type?.replaceAll(/['/.\s]/g, '');
    return (
      modName === 'Timeoff' &&
      isEditExistingMod &&
      (currentModDetails.approvalStatusId === 1 || currentModDetails.approvalStatusId === 4)
    );
  };

  const onSubmit = React.useCallback(
    formData => {
      const actionPayload = {
        selectedRow: selectedRowDetails,
        placementId: parseInt(param.placementId),
        formData,
        selectedButton,
        modDetails: failedAddMod ? modSavedResponse : currentModDetails,
        timeOffEditRequests,
        furnitureEditRequests,
        utilityEditRequests,
        payrollShiftEditRequests,
        reimbursementCategoryAndFrequency,
        preferenceModEditRequests,
        billingShiftEditRequests,
        gwwExceptionsTypes,
        pricingReasons,
      };
      if (!isEditExistingMod && isModEdit) {
        dispatch(placementModsAction.business_createPlacementMod(actionPayload));
      } else {
        dispatch(placementModsAction.business_updatePlacementMod(actionPayload));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      billingShiftEditRequests,
      currentModDetails,
      failedAddMod,
      furnitureEditRequests,
      gwwExceptionsTypes,
      isEditExistingMod,
      modSavedResponse,
      param.placementId,
      payrollShiftEditRequests,
      preferenceModEditRequests,
      pricingReasons,
      reimbursementCategoryAndFrequency,
      selectedButton,
      selectedRowDetails,
      timeOffEditRequests,
      utilityEditRequests,
    ],
  );

  const getErrorMessage = () => {
    return modSavedResponse?.message;
  };

  const getRefreshAction = () => {
    onClose();
  };

  const onClose = () => {
    reset();
    dispatch(placementModsAction.setDefaultModDetails(null));
    dispatch(placementModsAction.setCurrentModsDetails(null));
    dispatch(placementModsAction.setOpenModForAdding(null));
    dispatch(placementModsAction.setIsModEdit(null));
    dispatch(placementModsAction.setModSavedStatus(null));
    dispatch(placementModsAction.setIsEditExistingMod(null));
    setModsDialogDetails({ ...modsDialogDetails, isOpen: false });
    dispatch(placementModsAction.setEditTimeOffRows([]));
    dispatch(placementModsAction.setGridModAltered(false));
    dispatch(placementModsAction.setTimeOffHoursError([]));
    dispatch(placementModsAction.setTimeOffStartDateError([]));
    dispatch(placementModsAction.setTimeOffEndDateError([]));
    dispatch(placementModsAction.setFurnitureQuantityError([]));
    dispatch(placementModsAction.setGridModError(false));
    dispatch(placementModsAction.setFurnitureCostToTravelError([]));
    dispatch(placementModsAction.setInsuranceEffectiveType(null));
    dispatch(placementModsAction.setStandard(false));
    dispatch(placementModsAction.setHousingBannerDisplay(false));
    //*START Preference Mod
    //Adult Grid
    dispatch(placementModsAction.setEditAdultRows([]));
    dispatch(placementModsAction.setAdultGridmodAltered(false));
    dispatch(placementModsAction.setAdultGridmodError(false));
    dispatch(placementModsAction.setPreferenceAdultNameError([]));
    dispatch(placementModsAction.setPreferenceAdultRelationshipError([]));

    //Children Grid
    dispatch(placementModsAction.setEditChildrenRows([]));
    dispatch(placementModsAction.setChildrenGridModAltered(false));
    dispatch(placementModsAction.setChildrenGridModError(false));
    dispatch(placementModsAction.setPreferenceChildrenGenderError([]));
    dispatch(placementModsAction.setPreferenceChildrenAgeError([]));

    //Pets Grid
    dispatch(placementModsAction.setEditPetsRows([]));
    dispatch(placementModsAction.setPetsGridModAltered(false));
    dispatch(placementModsAction.setPetsGridModError(false));
    dispatch(placementModsAction.setPreferencePetsTypeError([]));

    //*END Preference Mod
    dispatch(placementModsAction.setEditPayrollShiftDiffRows([]));
    dispatch(placementModsAction.setEditBillingShiftDiffRows([]));
    dispatch(placementModsAction.setShiftDifferentialStartTimeError([]));
    dispatch(placementModsAction.setShiftDifferentialEndTimeError([]));
    dispatch(placementModsAction.setShiftDifferentialAmountError([]));
    dispatch(placementModsAction.setShiftDifferentialTypeError([]));
    dispatch(placementModsAction.setShiftDifferentialDescriptionTypeError([]));
    dispatch(placementModsAction.setCustomTemplateType(false));
    dispatch(placementModsAction.setOriginCustomTemplateChanged(false));
    dispatch(placementModsAction.setIsApprovedTravelerState(null));
    dispatch(placementModsAction.setIsApprovedNonTravelerState(null));
  };

  const getVoidStatusButton = () => {
    setShowVoidButton(currentModDetails?.enableVoidOption === false || currentModDetails?.enableVoidOption === true);
    setNoOptions(
      currentModDetails?.approvalStatusOptions?.length === 0 &&
        currentModDetails?.acceptanceStatusOptions?.length === 0,
    );
  };

  const getTooltTip = () => {
    return selectedModValue(modsDialogDetails) === EndDate || selectedModValue(modsDialogDetails) === StartDate
      ? t('placement.placementMods.voidDisabledForDates')
      : t('placement.placementMods.voidDisabledCommon');
  };
  const isErrorMod =
    Object.keys(errors).length !== 0 ||
    effectiveDateError.status ||
    isSaveModApiCalling ||
    isVoidModApiCalling ||
    isDeleteModApiCalling ||
    isGridModError ||
    isAdultGridmoderror ||
    isChildrenGridmodError ||
    isPetsGridModError ||
    (selectedModValue(modsDialogDetails) === 'Preferences' && !isEditExistingMod && preferenceGridEmptyError) ||
    (modSavedResponse && modSavedResponse?.responseCode === refreshErrorCode);

  const getSaveDisabled = () => {
    // If it's an approved traveler bonus or approved non-traveler bonus, always enable save
    if (isApprovedTravelerBonus || isApprovedNonTravelerBonus) {
      return false;
    }

    // Prevent save row is actively in edit mode
    if (isRowInEditMode) {
      return true;
    }

    if (!isModEdit && !isEditExistingMod) {
      return true;
    } else if (isEditExistingMod && !isModAltered && !isErrorMod) {
      return true;
    } else if (!isErrorMod && isModEdit) {
      return false;
    } else {
      if (isErrorMod) {
        return true;
      } else {
        return false;
      }
    }
  };

  const getEffectiveDate = () => {
    if (currentModDetails || isTimeOffModDate) {
      if (isDateModGreaterBookingDate()) {
        return moment(new Date())?.format('YYYY-MM-DDTHH:mm:ss');
      } else {
        return moment(currentModDetails?.effectiveDate)?.format('YYYY-MM-DDTHH:mm:ss');
      }
    }
  };

  const getUndoEffectiveDate = () => {
    if (currentModDetails) {
      if (isDateModGreaterBookingDate()) {
        return moment(new Date())?.format('YYYY-MM-DDTHH:mm:ss');
      } else {
        return moment(currentModDetails?.effectiveDate)?.format('YYYY-MM-DDTHH:mm:ss');
      }
    }
  };

  const onVoid = React.useCallback(() => {
    dispatch(
      placementModsAction.business_voidPlacementMod({
        placementId: currentModDetails?.placementId,
        travelerOptionId: currentModDetails?.travelerOptionId,
        travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
        modTitle: dialogTitle(),
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentModDetails?.placementId,
    currentModDetails?.travelerOptionId,
    currentModDetails?.travelerOptionTimestamp,
    dialogTitle,
  ]);

  const onDelete = React.useCallback(() => {
    dispatch(
      placementModsAction.business_deletePlacementMod({
        placementId: currentModDetails?.placementId,
        travelerOptionId: failedAddMod ? modSavedResponse?.travelerOptionId : currentModDetails?.travelerOptionId,
        travelerOptionTimestamp: failedAddMod
          ? sanitizeString(modSavedResponse?.travelerOptionTimestamp)
          : sanitizeString(currentModDetails?.travelerOptionTimestamp),
        modTitle: dialogTitle(),
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentModDetails?.placementId,
    currentModDetails?.travelerOptionId,
    currentModDetails?.travelerOptionTimestamp,
    dialogTitle,
    failedAddMod,
    modSavedResponse?.travelerOptionId,
    modSavedResponse?.travelerOptionTimestamp,
  ]);

  const onUndoChanges = () => {
    setUndoButtonChanges(true);
    reset({ ...defaultModDetails });
    setEffectiveDateError({ status: false, helperText: '' });
    setSelectedButtons({
      ...selectedButton,
      approvedStatus: currentModDetails.approvalStatusId,
      acceptedStatus: currentModDetails.acceptanceStatusId,
      effectiveDate: getUndoEffectiveDate(),
      isDelete: false,
      isVoid: false,
    });
    setOpenUndoModal(false);
    setAlteredEffectiveDate(false);
    if (selectedModValue(modsDialogDetails) === 'Timeoff') {
      dispatch(placementModsAction.setEditTimeOffRows(getFormattedTimeOff(currentModDetails?.timeOffRequests)));
      dispatch(placementModsAction.setGridModAltered(false));
    }
    if (selectedModValue(modsDialogDetails) === 'Furniture') {
      dispatch(placementModsAction.setEditFurnitureRows(getFormattedFurniture(currentModDetails?.furniture)));
      dispatch(placementModsAction.setEditUtilitiesRows(getFormattedUtility(currentModDetails?.utilities)));
      dispatch(placementModsAction.setGridModAltered(false));
    }
    if (selectedModValue(modsDialogDetails) === 'InterimTravel') {
      dispatch(placementModsAction.setGridModAltered(false));
    }
    if (selectedModValue(modsDialogDetails) === 'PayrollShiftDifferential') {
      dispatch(
        placementModsAction.setEditPayrollShiftDiffRows(
          getFormattedPayrollShiftDifferential(
            currentModDetails?.shiftDifferentials,
            shiftDifferentialTypes,
            shiftDifferentialDescriptionTypes,
            isModEdit,
          ),
        ),
      );
      dispatch(placementModsAction.setGridModAltered(false));
      if (currentModDetails.shiftDifferentialTemplateTypeId?.toString() !== TemplateTypes.Custom.toString()) {
        dispatch(placementModsAction.setCustomTemplateType(false));
        dispatch(placementModsAction.setOriginCustomTemplateChanged(true));
      }
    }
    if (selectedModValue(modsDialogDetails) === 'Preferences') {
      //Preference Adult Grid
      dispatch(placementModsAction.setEditAdultRows(currentModDetails?.travelerInfo?.adults));
      dispatch(placementModsAction.setAdultGridmodAltered(false));
      //Preference Children Grid
      dispatch(placementModsAction.setEditChildrenRows(currentModDetails?.travelerInfo?.children));
      dispatch(placementModsAction.setChildrenGridModAltered(false));
      //Preference Pets Grid
      dispatch(placementModsAction.setEditPetsRows(currentModDetails?.travelerInfo?.pets));
      dispatch(placementModsAction.setPetsGridModAltered(false));
    }
    if (selectedModValue(modsDialogDetails) === 'BillingShiftDifferential') {
      dispatch(
        placementModsAction.setEditBillingShiftDiffRows(
          getFormattedBillingShiftDifferential(
            currentModDetails?.shiftDifferentials,
            shiftDifferentialTypes,
            shiftDifferentialDescriptionTypes,
            isModEdit,
          ),
        ),
      );
      dispatch(placementModsAction.setGridModAltered(false));
      if (currentModDetails.shiftDifferentialTemplateTypeId?.toString() !== TemplateTypes.Custom.toString()) {
        dispatch(placementModsAction.setCustomTemplateType(false));
        dispatch(placementModsAction.setOriginCustomTemplateChanged(true));
      }
    }
    if (selectedModValue(modsDialogDetails) === 'EMILMO') {
      dispatch(placementModsAction.setEmiLmoUndo(true));
    }
  };

  const getBannerWidth = React.useCallback(() => {
    switch (selectedModValue(modsDialogDetails)) {
      case 'MinReqHours':
        return '620px';
      case 'Reimbursement':
        return '623px';
      case 'StartDate':
      case 'EndDate':
        return '725px';
      case 'Timeoff':
        return '1160px';
      case 'BillRate':
        return '1362px';
      case 'PayRate':
        return '1062px';
      case 'Insurance':
        return '635px';
      case 'InterimTravel':
        return '899px';
      case 'PayrollShiftDifferential':
      case 'BillingShiftDifferential':
        return '1305';
      case 'Preferences':
        return '922px';
      case 'Bonus':
        return '923px';
      case 'Furniture':
        return '1160px';
      case 'Housing':
        return '1006px';
      case 'EMILMO':
        return isEmiLmoDisabled ? '1006px' : '725px';
      default:
        return '725px';
    }
  }, [isEmiLmoDisabled, modsDialogDetails]);

  useEffect(() => {
    getVoidStatusButton();

    if (currentModDetails && Object.keys(currentModDetails).length > 0) {
      showEmiLmoStartEndDateMissingBannerInfo();
    }
    if (currentModDetails) {
      setSelectedButtons({
        ...selectedButton,
        approvedStatus: currentModDetails.approvalStatusId,
        acceptedStatus: currentModDetails.acceptanceStatusId,
        effectiveDate: getEffectiveDate(),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentModDetails]);

  useEffect(() => {
    if (defaultModDetails) reset({ ...defaultModDetails });
    setDefaultModState(defaultModDetails ?? '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultModDetails?.travelerOptionId]);

  useEffect(() => {
    if (selectedModValue(modsDialogDetails) === 'EMILMO') {
      dispatch(placementModsAction.setEmiLmoUndo(false));
    }
    return () => {
      setSelectedRowDetails({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dialogProps = {
    expanded,
    currentModDetails,
    selectedButton,
    setSelectedButtons,
    noOptions,
    modsDialogDetails,
    undoButtonChanges,
    setUndoButtonChanges,
    effectiveDateError,
    setEffectiveDateError,
    setAlteredEffectiveDate,
    isDirty,
    selectedRowDetails,
  };

  const isModAltered =
    isDirty ||
    effectiveDateAltered ||
    selectedButton?.approvedStatus !== currentModDetails?.approvalStatusId ||
    selectedButton?.acceptedStatus !== currentModDetails?.acceptanceStatusId ||
    selectedButton?.isDelete ||
    selectedButton?.isVoid ||
    isGridModAltered ||
    isAdultGridmodAltered ||
    isChildrenGridmodAltered ||
    isPetsGridmodAltered;

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.ctrlKey && event.key === 's') {
        if (!currentModDetails?.enableVoidOption && !selectedButton?.isDelete) handleSubmit(onSubmit)().catch(() => {});
        event.preventDefault();
      } else if (event.altKey && event.key === 'c') {
        if (isModAltered) {
          setCancelModalOpen(true);
        } else if (isModEdit && !isDirty && !effectiveDateAltered) {
          onClose();
        }
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isDirty,
    selectedButton,
    timeOffEditRequests,
    payrollShiftEditRequests,
    billingShiftEditRequests,
    furnitureEditRequests,
  ]);

  useEffect(() => {
    if (modSavedResponse?.responseCode === 0 || modSavedResponse?.responseCode === -2) {
      setFailedAddMod(false);
      onClose();
    } else if (modSavedResponse?.responseCode === effectiveDateErrorCode && !isEditExistingMod) {
      setFailedAddMod(true);
      setOpenApprovalModal(true);
      dispatch(placementModsAction.setGridModAltered(true));
    } else if (modSavedResponse?.responseCode === interimNoTimeoffAssociated && !isEditExistingMod) {
      setFailedAddMod(true);
      dispatch(placementModsAction.setIsEditExistingMod(true));
    } else if (modSavedResponse?.responseCode > 0) {
      // showing info meessage when amount to traveler is zero housing mod
      if (selectedModValue(modsDialogDetails) === 'Housing' && modSavedResponse?.responseCode === housingInfoMsgCode) {
        if (failedAddMod) {
          setFailedAddMod(true);
        } else {
          setFailedAddMod(false);
        }
      } else {
        setFailedAddMod(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modSavedResponse]);

  // Reset edit-mode flag when dialog closes
  useEffect(() => {
    return () => {
      dispatch(placementModsAction.setIsRowInEditMode(false));
    };
  }, [dispatch]);

  useEffect(() => {
    if (
      selectedButton?.acceptedStatus &&
      selectedButton?.acceptedStatus !== currentModDetails?.acceptanceStatusId &&
      currentModDetails.isBookingApprovedOrGreater &&
      selectedModValue(modsDialogDetails) === 'Bonus'
    ) {
      setSelectedButtons({ ...selectedButton, effectiveDate: FormatDate(new Date()) });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedButton?.acceptedStatus]);
  const doesHousingBannerDisplay = useSelector(selectDoesHousingBannerDisplay);
  const holdBannerShownState = useSelector(selectholdBannerShownState);

  const showEmiLmoStartEndDateMissingBannerInfo = () => {
    if (
      selectedModValue(modsDialogDetails) === 'EMILMO' &&
      (!placementDetails.placementStartDate || !placementDetails.placementEndDate)
    ) {
      dispatch(
        placementModsAction.setModSavedStatus({
          ...modSavedResponse,
          placementStartDate: placementDetails?.placementStartDate,
          placementEndDate: placementDetails?.placementEndDate,
          message: t('placement.placementMods.emiLmoDatesMissingMessage'),
          responseCode: 2,
        }),
      );
      dispatch(placementModsAction.setBannerShownState(true));
      dispatch(placementModsAction.setEmiLmoDisabled(true));
    }
  };

  // for houing When Actual Housing Type = Subsidy and Amount to Traveler =0.00, then display an informative banner,
  const showHousingInfoBanner = () => {
    if (modSavedResponse?.responseCode === housingInfoMsgCode) {
      if (modSavedResponse?.responseCode === housingInfoMsgCode && doesHousingBannerDisplay === false) {
        const storage = JSON.parse(localStorage.getItem('housingBannerMsg'));
        let display: boolean = true;

        if (storage && storage.length > 0) {
          for (let index = 0; index < storage.length; index++) {
            const item = storage[index];
            if (currentModDetails?.travelerOptionId === item.travelerOptionId && item.msgShown === true) {
              display = false;
            }
          }
          dispatch(placementModsAction.setHousingBannerDisplay(true));
          dispatch(placementModsAction.setBannerShownState(display));
          return display;
        } else {
          dispatch(placementModsAction.setHousingBannerDisplay(true));
          dispatch(placementModsAction.setBannerShownState(true));
          return true;
        }
      } else {
        return holdBannerShownState;
      }
    } else {
      return true;
    }
  };

  return (
    <GenericDialog
      open={modsDialogDetails.isOpen}
      className={classes.modalContainer}
      variant="blue"
      disableEnforceFocus
      fullWidth
      onClose={(event, reason) => {
        if (isModAltered && currentModDetails) {
          setCancelModalOpen(true);
        } else if (reason !== 'backdropClick') {
          onClose();
        }
      }}
      draggable
      dialogTitleProps={{
        text: `${dialogTitle()}`,
        closeButton: true,
        expandable: true,
        undoButton: true,
        disableUndo: !isModAltered,
        onUndoClick: () => {
          setOpenUndoModal(true);
        },
        onExpandChange: expand => {
          setExpanded(expand);
          dispatch(placementModsAction.setExpandedModsDialog(expand));
        },
      }}
    >
      <>
        {isCallingAPI && !currentModDetails && (
          <Grid container xs={12} className={classes.parentGrid} style={{ minHeight: '10rem' }}>
            <CircularProgress className={classes.validationLoader} />
          </Grid>
        )}
        {(isSaveModApiCalling || isVoidModApiCalling || isDeleteModApiCalling) && (
          <Grid container xs={12}>
            <CircularProgress className={classes.validationLoader} />
          </Grid>
        )}
        {modSavedResponse?.responseCode &&
          modSavedResponse?.responseCode > 1 &&
          (modSavedResponse?.responseCode !== effectiveDateErrorCode || isEditExistingMod) &&
          showHousingInfoBanner() && (
            <Grid item xs={12} className={classes.banner} style={{ maxWidth: expanded ? 'none' : getBannerWidth() }}>
              <ModsFormBanner
                refreshButton={modSavedResponse?.responseCode === refreshErrorCode}
                message={getErrorMessage()}
                refreshAction={getRefreshAction}
              />
            </Grid>
          )}
        {defaultModState && (
          <Grid
            container
            className={classes.parentGrid}
            sx={{ height: modSavedResponse?.responseCode > 1 ? '95%' : '100%' }}
          >
            <Grid
              className={classes.modHeight}
              style={{
                width: expanded ? 'inherit' : 'auto',
                padding: modSavedResponse?.responseCode > 1 ? '24px 24px 65px 24px' : '24px',
              }}
            >
              <FormProvider {...formMethods}>
                <form style={{ width: expanded ? getModsWidth(selectedModValue(modsDialogDetails)) : null }}>
                  <ModsComponent selectedRowDetails={selectedRowDetails} />
                </form>
              </FormProvider>
            </Grid>

            <Grid
              className={classes.gridContainers}
              style={{
                width: expanded ? '440px' : 'auto',
                padding: modSavedResponse?.responseCode > 1 ? '24px 24px 65px 24px' : '24px',
              }}
            >
              {currentModDetails && (
                <>
                  <Grid>
                    <DialogButtonComponent {...dialogProps} />
                  </Grid>
                </>
              )}

              <Grid>
                <div className={expanded ? classes.expandedBtn : classes.alignBtn}>
                  <Button
                    className={classes.cancelBtn}
                    variant="contained"
                    disabled={isSaveModApiCalling}
                    onClick={() => {
                      if (isModAltered) {
                        setCancelModalOpen(true);
                      } else {
                        onClose();
                      }
                    }}
                  >
                    {t('placement.placementMods.cancel')}
                  </Button>
                  {!selectedButton?.isDelete && !selectedButton.isVoid && (
                    <Button
                      variant="contained"
                      onClick={() => {
                        handleSubmit(onSubmit)().catch(() => {});
                      }}
                      className={classes.submitButton}
                      disabled={getSaveDisabled()}
                    >
                      {' '}
                      {t('placement.placementMods.save')}
                    </Button>
                  )}
                  {selectedButton?.isDelete && !showVoidButton && (
                    <Button
                      variant="contained"
                      className={classes.submitButton}
                      disabled={!selectedButton?.isDelete}
                      onClick={() => {
                        onDelete();
                      }}
                    >
                      {t('placement.placementMods.delete')}
                    </Button>
                  )}
                  {selectedButton?.isVoid && (
                    <WhiteTooltip
                      title={currentModDetails?.enableVoidOption === false ? getTooltTip() : ''}
                      PopperProps={{
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, -5],
                            },
                          },
                        ],
                      }}
                    >
                      <span>
                        <Button
                          variant="contained"
                          disabled={!selectedButton?.isVoid}
                          className={classes.submitButton}
                          onClick={() => {
                            handleSubmit(onVoid)().catch(() => {});
                          }}
                        >
                          {t('placement.placementMods.void')}
                        </Button>
                      </span>
                    </WhiteTooltip>
                  )}
                  <Cancel
                    openDialog={openCancelModel}
                    handleConfirmAction={() => setModsDialogDetails({ ...modsDialogDetails, isOpen: false }, onClose())}
                    handleCancelAction={() => {
                      setCancelModalOpen(false);
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>
        )}
      </>
      <Undo
        openDialog={openUndoModal}
        handleConfirmAction={() => {
          dispatch(placementModsAction.setIsUndoModal(true));
          onUndoChanges();
        }}
        handleCancelAction={() => {
          setOpenUndoModal(false);
          setUndoButtonChanges(false);
        }}
      />
      <CannotApprovedModal
        openDialog={openApprovalModal}
        handleConfirmAction={() => {
          dispatch(placementModsAction.setIsEditExistingMod(true));
          dispatch(placementModsAction.setGridModAltered(false));
          setFailedAddMod(true);
          setOpenApprovalModal(false);
        }}
      />
    </GenericDialog>
  );
};
